export default "__VITE_ASSET__PfAdgylL__"